import React from 'react';
import { DialogContent,Slide,Dialog,DialogTitle } from '@material-ui/core';
import "./styles.css";
import { saveAs } from 'file-saver';
import { toast } from "react-toastify";
import CloseIcon from '@material-ui/icons/Close';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import { Scrollbars } from "react-custom-scrollbars";
import DocViewer,{ DocViewerRenderers } from "react-doc-viewer";

function FileViewerComp({previewFile,setPreviewFile}){
  let docs = [{uri:previewFile.filepath}]; 

  const Transition = React.forwardRef(function Transition(props, ref) {
      return <Slide direction="up" ref={ref} {...props} />;
    });

  const handleClickClose = () => {
    setPreviewFile({open:false,filename:"",filentype:"",filepath:""})
  };

  const handleDownload = ()=>{
    //setPreviewFile({...previewFile, open:true});
    saveAs(previewFile.filepath, previewFile.filename);
    toast("Downloading in progress!")
  }

  return (
    <div>
      {
       <Dialog style={{overflow:'scroll'}} fullWidth={true} maxWidth="lg" open={previewFile.open} onClose={handleClickClose} TransitionComponent={Transition}>
        <div style={{height:"6vh",alignItems:"center",display:'flex',justifyContent:"space-between",flexDirection:"row-reverse",paddingLeft:"3vh",paddingTop:"3vh"}}>
          <div style={{display:"flex",flexDirection:"row-reverse",justifyContent:"space-between",height:'5vh',width:"9vw",marginTop:"-1vh",paddingRight:"7vh",paddingTop:'1vh'}}>
            <CloseIcon style={{cursor:"pointer",fontSize:"3.5vh"}} onClick={handleClickClose}/>
            <GetAppRoundedIcon style={{cursor:"pointer",fontSize:"3.5vh"}} onClick={handleDownload} />
          </div>
          <DialogTitle id="max-width-dialog-title">{previewFile.filename}</DialogTitle>
        </div>
        <DialogContent>
          <div id="view">
            <Scrollbars autoHide={true} style={{height:'70vh',width:'auto'}}>
              <DocViewer style={{height:'100%'}} pluginRenderers={DocViewerRenderers}  documents={docs} config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                  retainURLParams: true
                }
              }} />
            </Scrollbars>
          </div>
        </DialogContent>
       </Dialog>
      }
      </div>
  )
}
export default FileViewerComp